import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../utils/itemValidation';

import Slider from 'react-slick';

import AntiModal from '../../common/modal/AntiModal';
import RhinoSelect from '../../common/inputs/RhinoSelect';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class CustomDesign extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let locationArray= firstEntry.concat(locations.locations).concat(finalEntry);

		this.state = {
			videoModalOpen: false,
			formModalOpen: false,

			sliderSettings: {
				dots: false,
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 2,
				centerMode: false,
				autoplay: true,
				speed: 500,
				autoplaySpeed: 5000,
				cssEase: "linear",
				arrows: false,
		    },

		    locations: locationArray,

			inputName: '',
			inputLastName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputJewelry: '',
			inputDiamond: '',
			inputMetal: '',


			errorName: null,
			errorLastName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorJewelry: null,
			errorDiamond: null,
			errorMetal: null,

		}
	}

	componentWillMount() {
		document.title = 'Diamonds Direct Custom Design';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openVideoModal() {
  	this.setState({ videoModalOpen: true });
  }

  closeVideoModal() {
  	this.setState({ videoModalOpen: false });
  }

  openFormModal() {
  	this.setState({ formModalOpen: true });
  }

  closeFormModal() {
  	this.setState({ formModalOpen: false });
  }

  nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeLastName(evt) {
		this.setState({ inputLastName: evt.target.value }, () => {
			if(this.state.errorLastName && !nameValidation(this.state.inputLastName)) {
				this.setState({ errorLastName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeJewelry(evt) {
		this.setState({ inputJewelry: evt.target.value });
	}

	changeDiamond(evt) {
		this.setState({ inputDiamond: evt.target.value });
	}

	changeMetal(evt) {
		this.setState({ inputMetal: evt.target.value });
	}

	changeMessage(evt) {
		this.setState({ inputMessage: evt.target.value}, () => {
			// if(this.state.errorMessage !== false && this.state.inputMessage !== '') {
			// 	this.setState({errorMessage: null});
			// }
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName + this.state.inputLastName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
				jewelry: this.state.inputJewelry,
				diamond: this.state.inputDiamond,
				metal: this.state.inputMetal,
				description: this.state.inputMessage
			}

			this.props.commonCustomDesignContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping');
			this.setState({
				inputName: '',
				inputLastName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputMessage: '',
				inputJewelry: '',
				inputDiamond: '',
				inputMetal: '',
				formModalOpen: false,
				errorName: null,
				errorLastName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let lastNameError = nameValidation(this.state.inputLastName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorLastName: lastNameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='CustomDesign'>
			<div className='designHeader'>Custom Designs</div>
			<div className='designSubheader'>
				<div className='subheaderDiamond'>
					<img src='https://ddw2.diamondsdirect.com/img/customdesign/diamond.png' />
				</div>
				<div className='subheaderTitle'>Designed with you. Created for you.</div>
				<div className='subheaderText'>Designing a custom ring is a simple, easy process. Tell us what you want and our designers &amp; custom design jewelry specialists will bring your inspiration to life!</div>
			</div>
			<div className='stepsWrapper'>
				<div className='stepTop'>
					<img src='https://ddw2.diamondsdirect.com/img/customdesign/custom1.png' />
				</div>
				<div className='stepBody'>
					<div className={'imgElement rightImg imgOne'}>
						<img src='https://ddw2.diamondsdirect.com/img/customdesign/custom2.png' />	
					</div>
					<div className={'stepElement leftStep stepOne'}>
						<div className='stepNumber'>1</div>
						<div className='stepText'>Send us a sketch, links, photos, or write a description of your dream jewelry.</div>
						<div className='stepArrow'>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/arrow_rp.svg' />
						</div>
					</div>
					<div className={'stepElement rightStep stepTwo'}>
						<div className='stepNumber'>2</div>
						<div className='stepText'>Our designers will create a 3D design of your ring for you to review and approve.</div>
						<div className='stepArrow'>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/arrow_lp.svg' />
						</div>
					</div>
					<div className={'stepElement leftStep stepThree'}>
						<div className='stepNumber'>3</div>
						<div className='stepText'>Once the 3D design is approved, we will create a wax version of the ring using 3D printers.</div>
						<div className='stepArrow'>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/arrow_rp.svg' />
						</div>
					</div>
					<div className={'stepElement rightStep stepFour'}>
						<div className='stepNumber'>4</div>
						<div className='stepText'>Upon final approval, we cast your design in the desired metal. The ring is passed on to our goldsmiths, engravers, and diamond setters who hand finish your special creation just as you imagined.</div>
						<div className='stepArrow'>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/arrow_lp.svg' />
						</div>
					</div>
					<div className={'imgElement leftImg imgTwo'}>
						<img src='https://ddw2.diamondsdirect.com/img/customdesign/custom3.png' />
					</div>
				</div>
				<div className='stepBottom'>
					<img src='https://ddw2.diamondsdirect.com/img/customdesign/custom4.png' />
				</div>
			</div>
			<div className='buttonWrapper'>
				<div className='formButton' onClick={::this.openFormModal}>Let's Get Started</div>
			</div>
			<div className={this.state.formModalOpen ? 'formExpansionWrapper open' : 'formExpansionWrapper'}>

					
				<div className='formWrapper'>
					<div className='formInputWrapper'>
						<input 
							className={this.state.errorName ? 'textInput error' : 'textInput'}
							type='text' 
							placeholder='First Name*'
							value={this.state.inputName}
        					onChange={::this.changeName} />
					</div>
					<div className='formInputWrapper'>
						<input 
							className={this.state.errorLastName ? 'textInput error' : 'textInput'}
							type='text' 
							placeholder='Last Name*'
							value={this.state.inputLastName}
        					onChange={::this.changeLastName} />
					</div>
					<div className='formInputWrapper'>
						<input 
							className={this.state.errorEmail ? 'textInput error' : 'textInput'}
							type='email' 
							placeholder='Email Address*'
							value={this.state.inputEmail}
        					onChange={::this.changeEmail} />
					</div>
					<div className='formInputWrapper'>
						<input 
							className={this.state.errorPhone ? 'textInput error' : 'textInput'}
							type='text' 
							placeholder='Telephone'
							value={this.state.inputPhone}
        					onChange={::this.changePhone} />
					</div>
					<div className='formInputWrapper'>
						<RhinoSelect
              selectClass={'customSelect'}
              required={true}
              value={this.state.inputLocation}
              options={this.state.locations}
              changeMethod={(evt) => this.changeLocation(evt)}
              error={this.state.errorLocation !== null} />
					</div>

					<div className='formInputWrapper'>
						<input 
							className={this.state.errorJewelry ? 'textInput error' : 'textInput'}
							type='text' 
							placeholder='Jewelry Type'
							value={this.state.inputJewelry}
        					onChange={::this.changeJewelry} />
					</div>
					<div className='formInputWrapper'>
						<input 
							className={this.state.errorDiamond ? 'textInput error' : 'textInput'}
							type='text' 
							placeholder='Diamond Shape'
							value={this.state.inputDiamond}
        					onChange={::this.changeDiamond} />
					</div>
					<div className='formInputWrapper'>
						<input 
							className={this.state.errorMetal ? 'textInput error' : 'textInput'}
							type='text' 
							placeholder='Metal Type'
							value={this.state.inputMetal}
        					onChange={::this.changeMetal} />
					</div>

					<div className='textareaInputWrapper'>
						<textarea
              className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
              placeholder='Design description'
              value={this.state.inputMessage}
              onChange={::this.changeMessage}>
            </textarea>
					</div>
					<div className='formActionRow'>
						<button className={'formAction'} onClick={::this.submitContactRequest}>Submit Request</button>
					</div>
				</div>

			</div>
			<div className='imagesWrapper'>
				<div className='videoIcon' onClick={::this.openVideoModal}>
					<img src='https://ddw2.diamondsdirect.com/img/customdesign/videoFrame.jpg' />
				</div>
				<div className='imagesSlider'>
					<Slider ref={(slider) => { this.sliderObject = slider; }} {...this.state.sliderSettings}>
			  		<div className={'customDesignBanner rotatingBannerItem gridItem'}>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/001s.jpg' />
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/002s.jpg' />
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/003s.jpg' />
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/004s.jpg' />
						</div>
			  		<div className={'customDesignBanner rotatingBannerItem'}>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/005l.jpg' />
						</div>
						<div className={'customDesignBanner rotatingBannerItem gridItem'}>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/006s.jpg' />
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/007s.jpg' />
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/008s.jpg' />
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/009s.jpg' />
						</div>
						<div className={'customDesignBanner rotatingBannerItem'}>
							<img src='https://ddw2.diamondsdirect.com/img/customdesign/010l.jpg' />
						</div>
			  	</Slider>
				</div>
			</div>
			<AntiModal 
        open={this.state.videoModalOpen} 
        closeMethod={::this.closeVideoModal}
        resize={this.props.common.modalResize}
        theme={'customDesignVideo'}>
        <div className='closeIcon' onClick={::this.closeVideoModal}>
	        &times;
	      </div>
	      {this.state.videoModalOpen ?
	      	<iframe className='modalVideo' src="https://player.vimeo.com/video/118063536" frameborder="0" allowfullscreen></iframe> :
	      	null
	      }
      </AntiModal>
		</div>;
	}
}
export default CustomDesign;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
  };
}

export const CustomDesignContainer = connect(
  mapStateToProps,
  allActionCreators
)(CustomDesign);


// WEBPACK FOOTER //
// ./src/components/views/customdesign/CustomDesign.jsx